import React from 'react';
import { ArrowUpDown, ChevronDown, DownloadCloud, Loader2 } from 'lucide-react';

const labelClass = 'text-[10px] font-black uppercase tracking-widest text-slate-400';
const fieldClass = 'w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-2.5 text-xs font-black text-slate-700 outline-none';

const LedgerToolbar = ({
  sortDirection = 'desc',
  onSortDirectionChange,
  startDate = '',
  onStartDateChange,
  endDate = '',
  onEndDateChange,
  pdfLanguage = 'tr',
  onPdfLanguageChange,
  onExport,
  exporting = false,
  exportLabel = 'PDF / Dışa Aktar'
}) => (
  <div className="flex flex-col gap-3 border-b border-slate-100 bg-white px-5 py-3 sm:flex-row sm:flex-wrap sm:items-end">
    <label className="flex min-w-[200px] flex-1 flex-col gap-1">
      <span className={`inline-flex items-center gap-1 ${labelClass}`}>
        <ArrowUpDown size={12} />
        Sıralama
      </span>
      <select
        value={sortDirection}
        onChange={(event) => onSortDirectionChange?.(event.target.value === 'asc' ? 'asc' : 'desc')}
        className={fieldClass}
      >
        <option value="desc">Yeniden Eskiye (En Yeni Üstte)</option>
        <option value="asc">Eskiden Yeniye (En Eski Üstte)</option>
      </select>
    </label>

    <label className="flex min-w-[150px] flex-col gap-1">
      <span className={labelClass}>Başlangıç Tarihi</span>
      <input
        type="date"
        value={startDate}
        onChange={(event) => onStartDateChange?.(event.target.value)}
        className={fieldClass}
      />
    </label>

    <label className="flex min-w-[150px] flex-col gap-1">
      <span className={labelClass}>Bitiş Tarihi</span>
      <input
        type="date"
        value={endDate}
        onChange={(event) => onEndDateChange?.(event.target.value)}
        className={fieldClass}
      />
    </label>

    <label className="flex min-w-[140px] flex-col gap-1">
      <span className={labelClass}>PDF Dili</span>
      <div className="relative">
        <select
          value={pdfLanguage}
          onChange={(event) => onPdfLanguageChange?.(event.target.value)}
          className={`${fieldClass} appearance-none pr-10`}
        >
          <option value="tr">Türkçe</option>
          <option value="en">English</option>
          <option value="de">Deutsch</option>
        </select>
        <ChevronDown size={14} className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-slate-400" />
      </div>
    </label>

    <button
      type="button"
      onClick={onExport}
      disabled={exporting || typeof onExport !== 'function'}
      className="inline-flex h-[42px] shrink-0 items-center justify-center gap-2 rounded-2xl bg-slate-900 px-4 text-xs font-black uppercase tracking-widest text-white transition-colors hover:bg-black disabled:cursor-not-allowed disabled:opacity-60 sm:ml-auto"
    >
      {exporting ? <Loader2 size={14} className="animate-spin" /> : <DownloadCloud size={14} />}
      {exportLabel}
    </button>
  </div>
);

export default LedgerToolbar;
